import React, { useContext } from "react";
import { Col, Row, Form, Input, message, Card, Select, Tooltip, Switch, Button, Modal, ColorPicker } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { AuthContext } from "../../Auth/AuthContext";
import { addSource } from "../../utils/API";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { ArrowLeftOutlined } from "@ant-design/icons";
const { Option } = Select;

interface AddSourceModalProps {
    visible: boolean;
    onClose: () => void;
    onTaskCreated: () => void;
    isOpen?: boolean; // Make it optional if you still want to keep it
}
const AddSourceModal: React.FC<AddSourceModalProps> = ({ visible, onClose, onTaskCreated }) => {
    const navigate = useNavigate();
    const { authData } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = React.useState(false);
    const roleId = authData.roleId;



    const handleSubmit = async (values: any) => {
        try {
            setIsLoading(true);
            const colorValue =
                typeof values.color === "string"
                    ? values.color
                    : values.color?.toHexString?.() || "#000000";
            const payload = {
                name: values.name,
                category: values.category,
                color: colorValue,
            };
            await addSource(payload);

            message.success("Source added successfully!");
            form.resetFields();
            onTaskCreated();
            onClose();
        } catch (error: any) {
            message.error(getErrorMessage(error) || "Failed to add source. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
            centered={false}
            destroyOnClose
            className="custom-modal"
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Add Source
                </div>
            }
        >
            <Form
                onFinish={handleSubmit}
                form={form}
                layout="horizontal"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 19 }}
                colon={false}
                style={{ margin: 0 }}
            >


                {/* source Name */}
                <div className="elements">
                    <div className="flex justify-center gap-2">
                        {/* Source Name */}
                        <Form.Item
                            label={<span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>Source Name <span className="text-red-500">*</span></span>}
                            name="name"
                            required={false}
                            rules={[{ required: true, message: "Please enter Source name" }]}
                        >
                            <Input
                                className="Allinput"
                                placeholder="Source Name"
                                style={{ width: "380px" }}
                            />
                        </Form.Item>
                        <Form.Item
                            required={false}
                            name="color"
                            rules={[{ required: false, message: "Please pick a color" }]}
                            style={{ marginTop: "5px" }}
                            getValueFromEvent={(color) => color.toHexString()}
                        >
                            <ColorPicker
                                format="hex"
                                disabled={false}
                                placement="bottomRight"
                                // style={{ marginTop: "0px", position: "relative" }}
                                defaultValue={"#000000"}
                            // showText
                            />
                        </Form.Item>
                    </div>

                    <Form.Item
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Category <span className="text-red-500">*</span></span>}
                        name="category"
                        required={false}
                        rules={[
                            {
                                required: true,
                                message: "Please select a category",
                            },
                        ]}
                    >
                        <Select
                            mode="multiple"
                            size="large"
                            disabled={roleId == 2}
                            className="CustomSelect"
                            placeholder="Select category"

                        >
                            <Select.Option value="JobApplication">JobApplication</Select.Option>
                            <Select.Option value="Sales">Sales</Select.Option>
                            <Select.Option value="Contact">Contacts</Select.Option>
                        </Select>
                    </Form.Item>

                </div>
                {/* Submit Button */}
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={20}
                    className="d-flex justify-content-end me-3"
                >
                    <div className="button-wrapper">
                        <button
                            className="allcanclebutton"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button className="allsubmitebutton" disabled={isLoading}>
                            {isLoading ? "Add..." : "Add"}
                        </button>
                    </div>
                </Col>


            </Form>

        </Modal>
    );
};

export default AddSourceModal;
